import store from "@/store/store";

export const FAVORITE_CAMPAIGN_KEY = "FAVORITE_CAMPAIGN";
export function getFavoriteCampaign() {
  return store.state.storage[FAVORITE_CAMPAIGN_KEY] || localStorage.getItem(FAVORITE_CAMPAIGN_KEY);
}
export function setFavoriteCampaign(value) {
  store.commit(`storage/SET_${FAVORITE_CAMPAIGN_KEY}`, value);
  return localStorage.setItem(FAVORITE_CAMPAIGN_KEY, value);
}
export function deleteFavoriteCampaign() {
  store.commit(`storage/SET_${FAVORITE_CAMPAIGN_KEY}`, null);
  return localStorage.removeItem(FAVORITE_CAMPAIGN_KEY);
}

export const PINNED_CAMPAIGN_KEY = "FAVORITE_CAMPAIGN_PINNED";
export function getPinnedCampaign() {
  return store.state.storage[PINNED_CAMPAIGN_KEY] || localStorage.getItem(PINNED_CAMPAIGN_KEY);
}
export function setPinnedCampaign(value) {
  // The pinned favorite is fully independent of the selectors' last-selected value
  // (FAVORITE_CAMPAIGN). Opted-in selectors read the pinned value directly, so there is
  // no sync here — that keeps unpinning from leaving a stale default in the shared key.
  const id = String(value);
  store.commit(`storage/SET_${PINNED_CAMPAIGN_KEY}`, id);
  localStorage.setItem(PINNED_CAMPAIGN_KEY, id);
  return id;
}
export function deletePinnedCampaign() {
  store.commit(`storage/SET_${PINNED_CAMPAIGN_KEY}`, null);
  return localStorage.removeItem(PINNED_CAMPAIGN_KEY);
}
export function isCampaignPinned(id) {
  const pinned = getPinnedCampaign();
  return pinned != null && String(pinned) === String(id);
}

export const CAMPAIGN_LIST_LAYOUT_KEY = "CAMPAIGN_LIST_LAYOUT";
export function getCampaignListLayout() {
  const value =
    store.state.storage[CAMPAIGN_LIST_LAYOUT_KEY] || localStorage.getItem(CAMPAIGN_LIST_LAYOUT_KEY);

  if (!value) {
    return setCampaignListLayout("grid");
  }

  return value;
}
export function setCampaignListLayout(value) {
  store.commit(`storage/SET_${CAMPAIGN_LIST_LAYOUT_KEY}`, value);
  localStorage.setItem(CAMPAIGN_LIST_LAYOUT_KEY, value);
  return value;
}
